module.exports = __webpack_public_path__ + "img/Wacker_Chemie.75777373.png";